

export default class RequiresAsyncError extends Error {

}